 export default function objFromArray(array, key = 'id') {
    return array.reduce((accumulator, current) => {
      accumulator[current[key]] = current;
      return accumulator;
    }, {});
  }